import type { DecisionKind } from '@/types';

/** The most serious of a set of statuses: one rejected comment rejects. */
export function overallStage(stages: (DecisionKind | null | undefined)[]): DecisionKind | null {
  if (stages.includes('reject')) return 'reject';
  if (stages.includes('changes_requested')) return 'changes_requested';
  if (stages.includes('approve')) return 'approve';
  return null;
}
